import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useLocation } from 'react-router-dom'
import API from '../../services/API'

// Badge counts for the sidebar and header, from GET /nav-counts. Fetched on
// mount and then re-checked on navigation, throttled so route-hopping doesn't
// hammer the endpoint (it runs up to ~10 counts server-side).
const THROTTLE_MS = 45 * 1000

export const NavCountsContext = createContext({
  counts: {},
  refresh: () => {},
})

export const useNavCounts = () => useContext(NavCountsContext)

export const NavCountsProvider = ({ children }) => {
  const [counts, setCounts] = useState({})
  const lastFetched = useRef(0)
  const location = useLocation()

  const refresh = useCallback((force = false) => {
    if (!force && Date.now() - lastFetched.current < THROTTLE_MS) return
    lastFetched.current = Date.now()
    API.get('/nav-counts')
      .then((res) => {
        if (res.status === 200) setCounts(res.data?.counts ?? {})
      })
      .catch(() => {})
  }, [])

  useEffect(() => {
    refresh()
  }, [refresh, location.pathname])

  return (
    <NavCountsContext.Provider value={{ counts, refresh }}>
      {children}
    </NavCountsContext.Provider>
  )
}
